var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E2E2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 14.4912C27.5393 21.0619 25.9433 24.2864 20.2207 28.75C18.8897 27.7125 17.7782 26.7464 16.8535 25.7842C20.4315 24.3974 22.1041 23.041 23.7852 20.6484C21.1572 22.6231 19.3062 23.8052 15.8262 24.6191C15.1621 23.7902 14.6258 22.9433 14.1992 22.0342C18.9582 21.178 21.7896 19.0796 23.1367 17.3145C21.2724 18.3907 18.5705 20.1578 13.6611 20.6816C13.4073 19.9205 13.2134 19.1099 13.0723 18.2285C16.3341 17.482 18.0329 16.7528 19.8965 15.4629C17.9376 16.3141 16.3743 16.809 12.9229 17.1006C12.8374 16.2929 12.7868 15.4274 12.7666 14.4912L20.2207 11.25L27.1875 14.4912Z",
    fill: "url(#paint0_linear_13718_113973)",
    fillOpacity: 0.78
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13718_113973",
    x1: 27.3499,
    y1: 14.6528,
    x2: 10.012,
    y2: 14.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E8345",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAvatar);
export default __webpack_public_path__ + "static/media/emailAvatar.38f9302f939675dad4333461632b68db.svg";
export { ForwardRef as ReactComponent };